export default "__VITE_ASSET__DLf402wW__"